<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45">
		<defs></defs>
		<g transform="translate(-894 -434)"><path class="a" d="M0,0H45V45H0Z" transform="translate(894 434)"/><path d="M20.75,37.406l-2.719-2.475C8.375,26.175,2,20.4,2,13.312A10.212,10.212,0,0,1,12.313,3,11.228,11.228,0,0,1,20.75,6.919,11.228,11.228,0,0,1,29.188,3,10.212,10.212,0,0,1,39.5,13.312c0,7.087-6.375,12.863-16.031,21.638Z" transform="translate(895.75 436.625)"/></g>
	</svg>
</template>

<script>
export default {
	name: 'b-icon-favorite',
	components: {},
	computed: {},
	props: {},
};
</script>

<style scoped lang="scss">
  path.a {
    fill: none;
  }
</style>

<docs>
    IconFavorite

    ```js
    <b-icon-favorite />
    ```
</docs>
